<div *ngIf="busy">Fetching data...</div>
<div *ngIf="ladderOver">
  Thank you for playing! The ladder ended {{DateTime.fromISO(this.ladderInfo.endDate).toLocaleString(DateTime.DATETIME_MED)}}.
  <br /><br />
  <!-- If there is a tournament, you can see it <a href="#" [routerLink]="['/tournament', ladderid]">here</a> -->
</div>


<div *ngIf="!busy && !ladderOver" class="match-new">

  <!-- <div *ngIf="pairings.length == 0">No matches assigned yet... Please be patient... We are waiting for everyone to register.<br /><br /><br /><br />
  </div> -->
  <div *ngIf="pairings.length == 0">{{zero_pairing_msg}}<br /><a href="#" (click)="back($event)">Back</a></div>
  <div *ngIf="pairings.length > 0">

    <form [formGroup]="matchForm">
      <input type="hidden" formControlName="pairingId" />
      <input type="hidden" formControlName="pairingId" />
      <!-- TEMP: set *ngIf to true to show AI parse test again -->
      <div class="mb-3 p-2 border rounded bg-light" *ngIf="false">
        <label class="form-label mb-1" for="aiScorePhrase">Describe the match (AI parse test)</label>
        <div class="input-group input-group-sm">
          <input id="aiScorePhrase" type="text" class="form-control" [(ngModel)]="aiScorePhrase"
            [ngModelOptions]="{standalone: true}" placeholder="e.g. i beat eric 6-2, 7-6 (7-3)" autocomplete="off" />
          <button type="button" class="btn btn-outline-secondary" [disabled]="busyAiScore || !(aiScorePhrase || '').trim()"
            (click)="tryAiScoreParse()">Parse with AI</button>
        </div>
        <small class="text-muted d-block mb-1">Sends text to the server; opponent and scores are prefilled below when parsing succeeds.</small>
        <div *ngIf="aiParseHint" class="small" [class.text-success]="aiParseHintSuccess"
          [class.text-muted]="!aiParseHintSuccess">
          {{ aiParseHint }}
        </div>
      </div>
      <span *ngIf="round">Round {{round}}</span>
      <table class="table">
        <tr>
          <td>{{player.isDoubles ? 'Team' : 'Player'}}</td>
          <td>Set 1</td>
          <td>Set 2</td>
          <td>Set 3</td>
        </tr>
        <tr>
          <td>{{player.isDoubles ? player.doublesName : player.getFullName()}}</td>
          <td>
            <select #Set1Player1Score formControlName="Set1Player1Score">
              <option *ngFor="let s of possibleScores" [value]=s>{{s}}</option>
            </select>
            <select style="margin-left: 5px;" formControlName="Set1Player1Tie" *ngIf="+Set1Player1Score.value + +Set1Player2Score.value == 13">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{i}}</option>
            </select>
          </td>
          <td>
            <select #Set2Player1Score formControlName="Set2Player1Score">
              <option *ngFor="let s of possibleScores" [value]=s>{{s}}</option>
            </select>
            <select style="margin-left: 5px;" formControlName="Set2Player1Tie" *ngIf="+Set2Player1Score.value + +Set2Player2Score.value == 13">
              <option *ngFor=" let i of possibleTieScores" [value]="i">{{i}}</option>
            </select>
          </td>
          <td>
            <select #Set3Player1Score formControlName="Set3Player1Score">
              <option *ngFor="let s of possibleScores" [value]=s>{{s}}</option>
            </select>
            <select style="margin-left: 5px;" formControlName="Set3Player1Tie" *ngIf="+Set3Player1Score.value + +Set3Player2Score.value == 13">
              <option *ngFor=" let i of possibleTieScores" [value]="i">{{i}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>
            <select formControlName="opponentId">
              <option *ngFor="let s of pairings" [value]=s.pairingPlayer.id>{{s.pairingPlayer.name}}</option>
            </select>
          </td>
          <td>
            <select #Set1Player2Score formControlName="Set1Player2Score">
              <option *ngFor="let s of possibleScores" [value]=s>{{s}}</option>
            </select>
            <select style="margin-left: 5px;" formControlName="Set1Player2Tie" *ngIf="+Set1Player1Score.value + +Set1Player2Score.value == 13">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{i}}</option>
            </select>
          </td>
          <td>
            <select #Set2Player2Score formControlName="Set2Player2Score">
              <option *ngFor="let s of possibleScores" [value]=s>{{s}}</option>
            </select>
            <select style="margin-left: 5px;" formControlName="Set2Player2Tie" *ngIf="+Set2Player1Score.value + +Set2Player2Score.value == 13">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{i}}</option>
            </select>
          </td>
          <td>
            <select #Set3Player2Score formControlName="Set3Player2Score">
              <option *ngFor="let s of possibleScores" [value]=s>{{s}}</option>
            </select>
            <select style="margin-left: 5px;" formControlName="Set3Player2Tie" *ngIf="+Set3Player1Score.value + +Set3Player2Score.value == 13">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{i}}</option>
            </select>
          </td>
        </tr>
      </table>

      <div class="show-small" style="margin: 0 20px;">
        <div style="text-align: center;">
          <button class="btn btn-primary" [disabled]="!canSave() || busySave" (click)="saveMatch($event)">Submit Match</button>
        </div>
        <div style="text-align: center; margin-top: 15px;">
          <a href="#" (click)="saveRetired($event)">Submit Retired</a>
          &nbsp;
          <a href="#" (click)="saveForfeit($event)">Submit Forfeit</a>
          &nbsp;
          <a [routerLink]="['/home']">Cancel</a>
        </div>
      </div>
      <div class="hide-small">
        <button class="btn btn-primary" [disabled]="!canSave() || busySave" (click)="saveMatch($event)">Submit Match</button>

        <a style="padding-left: 50px;" href="#" (click)="saveRetired($event)">Submit Retired</a>
        &nbsp;|&nbsp;
        <a href="#" (click)="saveForfeit($event)">Submit Forfeit</a>
        &nbsp;|&nbsp;
        <a [routerLink]="['/home']">Cancel</a>
      </div>


    </form>
  </div>
</div>